import type { FC } from "react";
import { type SxProps, type Theme } from "@mui/material";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { config, PagePaths } from "@/partner/shared/constants";

export interface LogoProps {
  sx?: SxProps<Theme>;
}

export const Logo: FC<LogoProps> = ({ sx }) => {
  const { t } = useTranslation();

  return (
    <Box
      component={Link}
      to={PagePaths.partner}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        ...sx,
      }}
    >
      <img
        src={config.logoUrl}
        alt={t("shared.logo.alt")}
        style={{ maxWidth: "120px" }}
      />
    </Box>
  );
};
